import React, { Component } from "react";
import {
  Typography,
  Paper,
  Tabs as Tabs1,
  Tab as Tab1,
} from "@material-ui/core";
import { GetData } from "../../api/service";
import AcademicAbout from "../Academics/AcademicAbout";
import CollegeNotificationShort from "../College/CollegeNotificationShort";

const smallTab = [
  {
    title: "Policies, Regulations and Guidelines",
    active: 0,
  },
  {
    title: "Annual Internship Reports",
    active: 1,
  },
  {
    title: "Annual Activity Reports",
    active: 2,
  },
  {
    title: "Industry Collaboration Reports",
    active: 3,
  },
  {
    title: "Special Reports",
    active: 4,
  },
  {
    title: "Documents",
    active: 5,
  },
];

class InternshipDivisionHomeLanding extends Component {
  state = {
    active: 0,
    dept_code: "DISPUR",

    data: {},
    isDeptLoaded: false,
  };

  __getDeptData = (dept_code) => {
    GetData(`/admin/${dept_code}/getsingledeptdata`).then((resp) => {
      if (resp != false) {
        this.setState({
          data: resp,
          active: 0,
          isDeptLoaded: true,
        });
      } else {
        this.setState({
          data: {},
          active: 0,
          isDeptLoaded: true,
        });
      }
    });
  };

  componentDidMount() {
    this.__getDeptData(this.state.dept_code);
  }

  render() {
    return (
      <div>
        <Typography variant="h6">Internship Division</Typography>
        <Typography variant="subtitle2">
          Code: {this.state.dept_code}
        </Typography>

        <br />

        {this.state.isDeptLoaded && (
          <Paper square>
            <Tabs1
              value={this.state.active}
              indicatorColor="primary"
              textColor="primary"
              variant="scrollable"
              scrollButtons="auto"
              onChange={(e, newValue) =>
                this.setState({
                  active: newValue,
                })
              }
              aria-label=""
            >
              {smallTab.map((el, index) => (
                <Tab1 value={el.active} key={el.active} label={el.title} />
              ))}
            </Tabs1>
          </Paper>
        )}
        <br />

        {this.state.active == 0 ? (
          <AcademicAbout
            type={`INTERNSHIP_DIV_POLICIES`}
            title="Policies, Regulations and Guidelines"
          />
        ) : null}

        {this.state.active == 1 ? (
          <CollegeNotificationShort
            type={`INTERNSHIP_DIV_ANNUAL_REPORTS`}
            title="Annual Internship Reports"
          />
        ) : null}

        {this.state.active == 2 ? (
          <CollegeNotificationShort
            type={`INTERNSHIP_DIV_ACTIVITY_REPORTS`}
            title="Annual Activity Reports"
          />
        ) : null}

        {this.state.active == 3 ? (
          <CollegeNotificationShort
            type={`INTERNSHIP_DIV_COLLABORATION_REPORTS`}
            title="Industry Collaboration Reports"
          />
        ) : null}

        {this.state.active == 4 ? (
          <CollegeNotificationShort
            type={`INTERNSHIP_DIV_SPECIAL_REPORTS`}
            title="Special Reports"
          />
        ) : null}

        {this.state.active == 5 ? (
          <CollegeNotificationShort
            type={`INTERNSHIP_DIV_DOCUMENTS`}
            title="Documents"
          />
        ) : null}
      </div>
    );
  }
}

export default InternshipDivisionHomeLanding;
